document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('[data-solar-form]');
  if (!form) return;

  const consumosWrapper = form.querySelector('[data-consumos-wrapper]');
  const addPeriodoBtn = form.querySelector('[data-add-periodo]');
  const resumenBox = form.querySelector('[data-consumos-summary]');
  const inputHoras = form.querySelector('[name="horas_sol"]');
  const inputWPanel = form.querySelector('[name="w_panel"]');
  const estadoSelect = form.querySelector('[data-estado-select]');
  const resultBox = document.querySelector('[data-solar-result]');
  const tipoConsumoRadios = form.querySelectorAll('input[name="tipo_consumo"]');

  // Por defecto asumimos recibo bimestral (CFE)
  let mesesPorPeriodo = 2;

  // --- Datos de insolación NASA (promedio anual en horas por ciudad) ---
  const insolacionData = [
    { estado: 'Aguascalientes',      ciudad: 'Aguascalientes',      horas: 5.91 },
    { estado: 'Baja California',     ciudad: 'Tijuana',             horas: 5.07 },
    { estado: 'Baja California',     ciudad: 'Mexicali',            horas: 5.27 },
    { estado: 'Baja California Sur', ciudad: 'La Paz',              horas: 5.59 },
    { estado: 'Campeche',            ciudad: 'Campeche',            horas: 5.85 },
    { estado: 'Chiapas',             ciudad: 'Tuxtla Gutiérrez',    horas: 5.15 },
    { estado: 'Chihuahua',           ciudad: 'Juárez',              horas: 5.33 },
    { estado: 'Chihuahua',           ciudad: 'Chihuahua',           horas: 5.59 },
    { estado: 'Coahuila',            ciudad: 'Saltillo',            horas: 5.16 },
    { estado: 'Coahuila',            ciudad: 'Torreón',             horas: 5.58 },
    { estado: 'Colima',              ciudad: 'Colima',              horas: 5.61 },
    { estado: 'Distrito Federal',    ciudad: 'Ciudad de México',    horas: 5.46 },
    { estado: 'Durango',             ciudad: 'Durango',             horas: 5.73 },
    { estado: 'Estado de México',    ciudad: 'Toluca',              horas: 5.46 },
    { estado: 'Guanajuato',          ciudad: 'León',                horas: 5.79 },
    { estado: 'Guanajuato',          ciudad: 'Guanajuato',          horas: 5.79 },
    { estado: 'Guerrero',            ciudad: 'Acapulco',            horas: 6.14 },
    { estado: 'Guerrero',            ciudad: 'Chilpancingo',        horas: 5.68 },
    { estado: 'Hidalgo',             ciudad: 'Pachuca',             horas: 5.16 },
    { estado: 'Jalisco',             ciudad: 'Guadalajara',         horas: 5.81 },
    { estado: 'Michoacán',           ciudad: 'Morelia',             horas: 5.58 },
    { estado: 'Morelos',             ciudad: 'Cuernavaca',          horas: 5.94 },
    { estado: 'Nayarit',             ciudad: 'Tepic',               horas: 5.88 },
    { estado: 'Nuevo León',          ciudad: 'Monterrey',           horas: 4.94 },
    { estado: 'Nuevo León',          ciudad: 'Guadalupe',           horas: 5.50 },
    { estado: 'Oaxaca',              ciudad: 'Oaxaca',              horas: 5.26 },
    { estado: 'Puebla',              ciudad: 'Puebla',              horas: 5.40 },
    { estado: 'Querétaro',           ciudad: 'Querétaro',           horas: 5.86 },
    { estado: 'Quintana Roo',        ciudad: 'Cancún',              horas: 5.69 },
    { estado: 'Quintana Roo',        ciudad: 'Chetumal',            horas: 4.98 },
    { estado: 'San Luis Potosí',     ciudad: 'San Luis Potosí',     horas: 5.49 },
    { estado: 'Sinaloa',             ciudad: 'Culiacán',            horas: 5.98 },
    { estado: 'Sonora',              ciudad: 'Hermosillo',          horas: 5.73 },
    { estado: 'Tabasco',             ciudad: 'Villahermosa',        horas: 4.94 },
    { estado: 'Tamaulipas',          ciudad: 'Reynosa',             horas: 4.87 },
    { estado: 'Tamaulipas',          ciudad: 'Ciudad Victoria',     horas: 5.28 },
    { estado: 'Tlaxcala',            ciudad: 'Tlaxcala',            horas: 5.40 },
    { estado: 'Veracruz',            ciudad: 'Xalapa',              horas: 4.60 },
    { estado: 'Yucatán',             ciudad: 'Mérida',              horas: 5.30 },
    { estado: 'Zacatecas',           ciudad: 'Zacatecas',           horas: 5.76 }
  ];

  // --- Cambiar mesesPorPeriodo según radio (bimestral/mensual) ---
  if (tipoConsumoRadios.length) {
    tipoConsumoRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        mesesPorPeriodo = radio.value === 'mensual' ? 1 : 2;
        recalcularResumen();
      });
    });
  }

  // --- Función para recalcular el resumen de consumos ---
  function recalcularResumen() {
    if (!resumenBox) return;

    const inputs = consumosWrapper.querySelectorAll('input[name="consumo_bimestral[]"]');
    const consumos = [];
    inputs.forEach(input => {
      const val = parseFloat(String(input.value).replace(',', '.'));
      if (!isNaN(val) && val > 0) {
        consumos.push(val);
      }
    });

    if (!consumos.length) {
      resumenBox.textContent = 'Aún no has capturado consumos.';
      return;
    }

    const total = consumos.reduce((acc, v) => acc + v, 0);
    const n = consumos.length;
    const promedioPorRecibo = total / n;
    const promedioMensual = promedioPorRecibo / mesesPorPeriodo;
    const etiquetaRecibo = mesesPorPeriodo === 2 ? 'bimestral' : 'mensual';

    resumenBox.textContent =
      `Periodos: ${n} · Total: ${total.toFixed(1)} kWh · ` +
      `Prom. por recibo (${etiquetaRecibo}): ${promedioPorRecibo.toFixed(1)} kWh · ` +
      `Prom. mensual: ${promedioMensual.toFixed(1)} kWh`;
  }

  // --- Set up listeners de un periodo (input + botón borrar) ---
  function setupPeriodo(periodEl, allowDelete) {
    const input = periodEl.querySelector('input[name="consumo_bimestral[]"]');
    const deleteBtn = periodEl.querySelector('.solar-period-delete');

    if (input) {
      input.addEventListener('input', recalcularResumen);
    }

    if (deleteBtn) {
      deleteBtn.style.display = allowDelete ? 'inline-block' : 'none';

      deleteBtn.addEventListener('click', function () {
        periodEl.remove();
        // Renumerar
        const periodos = consumosWrapper.querySelectorAll('.solar-period');
        periodos.forEach((p, idx) => {
          const label = p.querySelector('.solar-period-label');
          if (label) label.textContent = 'Periodo ' + (idx + 1);
        });
        recalcularResumen();
      });
    }
  }

  // --- Inicializar primer periodo ---
  const primerPeriodo = consumosWrapper.querySelector('.solar-period');
  if (primerPeriodo) {
    setupPeriodo(primerPeriodo, false); // el primero no se puede borrar
  }

  // --- Llenar select de Estados y aplicar 10% de pérdida sobre horas promedio ---
  if (estadoSelect) {
    const estadosUnicos = [...new Set(insolacionData.map(item => item.estado))].sort();

    estadosUnicos.forEach(estado => {
      const opt = document.createElement('option');
      opt.value = estado;
      opt.textContent = estado;
      estadoSelect.appendChild(opt);
    });

    estadoSelect.addEventListener('change', function () {
      const estadoSel = this.value;

      if (!estadoSel) {
        inputHoras.value = '';
        return;
      }

      const ciudadesDeEstado = insolacionData.filter(item => item.estado === estadoSel);
      if (!ciudadesDeEstado.length) {
        inputHoras.value = '';
        return;
      }

      const totalHoras = ciudadesDeEstado.reduce((acc, item) => acc + item.horas, 0);
      const promedio = totalHoras / ciudadesDeEstado.length;

      const factorPerdidas = 0.10; // 10%
      const horasAjustadas = promedio * (1 - factorPerdidas);

      inputHoras.value = horasAjustadas.toFixed(2);
    });
  }

  // --- Agregar nuevos periodos dinámicos (vertical) ---
  if (addPeriodoBtn && consumosWrapper) {
    addPeriodoBtn.addEventListener('click', function () {
      const periodos = consumosWrapper.querySelectorAll('.solar-period');
      const count = periodos.length;

      if (count >= 12) {
        alert('Puedes capturar máximo 12 periodos.');
        return;
      }

      const template = periodos[0];
      const nuevo = template.cloneNode(true);

      const label = nuevo.querySelector('.solar-period-label');
      const input = nuevo.querySelector('input[name="consumo_bimestral[]"]');
      const deleteBtn = nuevo.querySelector('.solar-period-delete');

      if (label) label.textContent = 'Periodo ' + (count + 1);
      if (input) {
        input.value = '';
      }
      if (deleteBtn) {
        deleteBtn.style.display = 'inline-block';
      }

      consumosWrapper.appendChild(nuevo);
      setupPeriodo(nuevo, true);
      recalcularResumen();
    });
  }

  // --- Cálculo principal ---
  form.addEventListener('submit', function (e) {
    e.preventDefault();

    const consumoInputs = consumosWrapper.querySelectorAll('input[name="consumo_bimestral[]"]');
    const consumos = [];

    consumoInputs.forEach(function (input) {
      const val = parseFloat(String(input.value).replace(',', '.'));
      if (!isNaN(val) && val > 0) {
        consumos.push(val);
      }
    });

    const horasSol = parseFloat(String(inputHoras.value).replace(',', '.')) || 0;
    const wPanel = parseFloat(String(inputWPanel.value).replace(',', '.')) || 0;

    if (!consumos.length || !horasSol || !wPanel) {
      resultBox.innerHTML = '<p>Por favor llena al menos un consumo y los demás campos con números válidos.</p>';
      return;
    }

    const totalConsumo = consumos.reduce((acc, val) => acc + val, 0);
    const numPeriodos = consumos.length;

    // Si es bimestral, mesesPorPeriodo = 2; si es mensual = 1
    const consumoMensual = totalConsumo / (numPeriodos * mesesPorPeriodo);
    const consumoDiario = consumoMensual / 30;

    const potenciaKW = consumoDiario / horasSol;
    const potenciaW = potenciaKW * 1000;
    const numPaneles = Math.ceil(potenciaW / wPanel);

    const etiquetaRecibo = mesesPorPeriodo === 2 ? 'bimestral' : 'mensual';

    resultBox.innerHTML = `
      <p><strong>Resultado estimado con ${numPeriodos} periodo(s) capturado(s):</strong></p>
      <ul>
        <li>Tipo de recibo: <strong>${etiquetaRecibo}</strong></li>
        <li>Total de consumo ingresado: <strong>${totalConsumo.toFixed(1)} kWh</strong></li>
        <li>Consumo mensual promedio: <strong>${consumoMensual.toFixed(1)} kWh/mes</strong></li>
        <li>Consumo diario promedio: <strong>${consumoDiario.toFixed(1)} kWh/día</strong></li>
        <li>Horas efectivas de sol (ya con 10% de pérdidas): <strong>${horasSol.toFixed(2)} h/día</strong></li>
        <li>Potencia necesaria: <strong>${potenciaKW.toFixed(2)} kW</strong></li>
        <li>Cantidad aproximada de paneles de ${wPanel} W: <strong>${numPaneles}</strong></li>
      </ul>
      <p style="font-size: 0.85em;">* Esto es un cálculo aproximado. Para una propuesta formal, contáctanos.</p>
    `;
  });

  // Recalcular resumen al cargar
  recalcularResumen();
});
